'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import {
	businessContentAtom,
	TBusinessContent,
} from './BusinessPageContentState'
import { BusinessPageScreen } from './BusinessPageScreen/BusinessPageScreen'

export const BusinessPageLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TBusinessContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[businessContentAtom, content],
	])

	return <BusinessPageScreen previewMode={false} demoMode={false} />
}
